export default __webpack_public_path__ + "static/media/illustration.e39c176f.svg";